import React from 'react'
import useHasGeolocationPermission from 'hooks/useHasGeolocationPermission'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {NearbySuggestionButton} from './styles'

interface Props {
  onClick: () => void
}

export const SuggestionNearby = ({onClick}: Props) => {
  const geolocationPermissionStatus = useHasGeolocationPermission()

  return (
    <>
      <NearbySuggestionButton
        onClick={onClick}
        data-id="DestinationSuggestion--nearbySearch"
      >
        <Box padding="s500">
          <Box display="flex" alignItems="center" gap="s300">
            <Icon
              name="Location"
              size="md"
              colorPath="content.interactive.primary"
            />
            <Text colorPath="content.interactive.primary" variant="labelS">
              <FormattedMessageWrapper id="nearMe" defaultMessage="Near me" />
            </Text>
          </Box>
          <Box marginLeft="s600" paddingLeft="s200">
            {!geolocationPermissionStatus && (
              <Text
                variant="bodyS"
                colorPath="content.neutral.secondary"
                align="start"
              >
                <FormattedMessageWrapper
                  id="searchBox.enableLocation"
                  defaultMessage="Enable location services"
                />
              </Text>
            )}
          </Box>
        </Box>
      </NearbySuggestionButton>
    </>
  )
}
